<template>
  <div
    :class="{
      'absolute left-0 top-[3.8125rem] z-10 w-full shadow-[0_8px_16px_0_rgba(0,0,0,.2)] transition-all duration-0 md:top-[5.0625rem]': true,
      'border-www-color-primary-lighter md:border-t-2': true,
      'bg-www-color-neutral-medium-dark md:bg-www-color-white': true,
    }"
  >
    <!-- Divider in mobile view -->
    <div
      :class="{
        'divider ml-10 mr-25px w-full border-b border-www-color-neutral-medium md:hidden': true,
      }"
    ></div>

    <div
      :class="{
        'max-h-screen overflow-y-auto overflow-x-hidden pb-20 md:max-h-[calc(100vh-72px)] md:overflow-y-auto md:pb-0': true,
      }"
    >
      <div
        :class="{
          'gap-x-gutter grid grid-cols-12 gap-y-0 sm:grid-cols-8 md:grid-cols-12': true,
        }"
      >
        <div
          :class="{
            'left-col col-span-12 lg:col-span-4': true,
          }"
        >
          <div
            :class="{
              'flex flex-col pt-5 md:pt-0': true,
            }"
          >
            <NavProductCard v-bind="highlightCorner" />
            <NavFeaturedCard
              v-if="props.featureData"
              :heading="featuredCard?.heading"
              :card="props.featureData"
              menu-type="resources"
              :class="{
                'hidden md:block': true,
              }"
            />
          </div>
        </div>

        <div
          :class="{
            'right-col col-span-12 h-full px-8 py-50px md:px-70px lg:col-span-8': true,
            'grid grid-cols-12 gap-10': true,
            'bg-www-color-neutral-medium-dark md:bg-www-color-neutral-off-white': true,
          }"
        >
          <ResourcesMegaMenuColumn
            v-if="column1"
            v-bind="column1"
          />
          <ResourcesMegaMenuColumn
            v-if="column2"
            v-bind="column2"
          />
          <ResourcesMegaMenuColumn
            v-if="column3"
            v-bind="column3"
          />
        </div>
      </div>
      <div
        :class="{
          'bg-www-color-neutral-medium-dark md:bg-www-color-white': true,
        }"
      >
        <NavFeaturedCard
          v-if="props.featureData"
          :heading="featuredCard?.heading"
          :card="props.featureData"
          menu-type="resources"
          :class="{
            'block md:hidden': true,
          }"
        />
      </div>
    </div>
  </div>
</template>
<script setup lang="ts">
import type { ResourceDropdown, CardBlogResult } from '~/sanity/types';
import NavProductCard from './NavProductCard.vue';
import NavFeaturedCard from './NavFeaturedCard.vue';
import ResourcesMegaMenuColumn from './ResourcesMegaMenuColumn.vue';
type PropType = ResourceDropdown & {
  featureData?: CardBlogResult | null;
};

const props = withDefaults(defineProps<PropType>(), {
  featureData: null,
});
</script>
<style lang="scss" scoped></style>
